import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { v4 } from 'uuid';
import { Box, Typography, IconButton, } from '@mui/material';
import { useNavigate } from 'react-router';
import PlaceHolder from '../../portal/common/PlaceHolder';
import linkNavigator from '../../portal/common/linkNavigator';
const imageConfig = {
    google: {
        src: 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
        style: {
            width: '200px',
            height: '85.41px',
            marginTop: '-14px',
        },
    },
    apple: {
        src: 'https://developer.apple.com/news/images/download-on-the-app-store-badge.png',
        style: {
            padding: '14px',
            width: '200px',
            height: '85.375px',
            marginTop: '-14px',
        },
    },
};
const Title = ({ text }) => (_jsx(Typography, { sx: {
        typography: 'subtitle1',
        fontWeight: 'fontWeightBold',
        color: (theme) => theme.palette.greyCustom[800],
    }, children: text }));
const ListItemLink = (props) => {
    const { primary, } = props;
    const navigate = useNavigate();
    if (primary.url === '') {
        return null;
    }
    const renderIcon = (platform) => (_jsx("img", { src: imageConfig[platform].src, style: imageConfig[platform].style, alt: "alt" }));
    return (_jsx(Box, { style: {
            marginTop: '6px',
            marginBottom: '6px',
            display: 'inline-block',
        }, children: _jsx(IconButton, { sx: { color: (theme) => theme.palette.indigoCustom[700], mx: 1 }, onClick: () => {
                linkNavigator({ ...primary, type: 'social' }, navigate);
            }, children: renderIcon(primary.platform) }) }));
};
ListItemLink.defaultProps = {
    primary: undefined,
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AppstoreLinksWidget = ({ link, editData, limitToPageWidth, }) => {
    const isEmpty = () => {
        let isLinksEmpty = true;
        for (let i = 0; i < link.links.length; i += 1) {
            if (link.links[i].url) {
                isLinksEmpty = false;
            }
        }
        return link.title === '' && isLinksEmpty && editData;
    };
    if (isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Appstore Links Widget" }));
    }
    console.log('socialKinks:', link);
    return (_jsx(Box, { sx: {
            width: '100%',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsxs(Box, { sx: { width: '100%', mt: { lg: 0 } }, children: [link && _jsx(Title, { text: link.title }), link && link.links && link.links.map((subItem) => (_jsx(React.Fragment, { children: _jsx(ListItemLink, { primary: subItem }) }, subItem.id)))] }) }));
};
AppstoreLinksWidget.meta = {
    group: 'portal',
    name: 'Appstore Links',
    description: 'Displays links for Appstore.',
    props: [
        {
            key: 'link',
            name: 'Links',
            type: 'appstoreLinkList',
            description: 'Appstore links.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'AppstoreLinksWidget',
        props: {
            limitToPageWidth: true,
            link: {
                title: '',
                links: [
                    {
                        id: v4(),
                        platform: 'apple',
                        url: '',
                    },
                    {
                        id: v4(),
                        platform: 'google',
                        url: '',
                    },
                ],
            },
        },
    },
};
export default AppstoreLinksWidget;
//# sourceMappingURL=AppstoreLinksWidget.js.map